import { Injectable }         from '@angular/core';
import {
	TssManufacturerEnum,
	TssModeEnum,
	TssModeWithSubTypeEnum
}                             from '@app/modules/tss/models/tss.model';
import { UsageTssTypeEnum }   from '@app/modules/usage/models/fiskal-usage.model';
import { brandConfig }        from '@brand/configs/brand.config';
import {
	IBrandConfigDashboardPage,
	IBrandConfigSidebar,
	IBrandConfigTaskCenter,
	IBrandConfigTaxationReporting,
	IBrandConfigTenantConsolePage,
	IBrandConfigTssLifecycleModal
}                             from '@brand/configs/brand.config.interface';
import { BrandEnum }          from '@core/services/brand/brand.enums';
import { ChartColorTypeEnum } from '@shared/overview/overview.model';


@Injectable( { providedIn: 'root' } )
export class BrandService {

	get activeBranding(): BrandEnum {
		return brandConfig.activeBranding;
	}

	get appTitle(): string {
		return brandConfig.appTitle;
	}

	get availableTssManufacturers(): TssManufacturerEnum[] {
		const availableTssManufacturers: TssManufacturerEnum[] = [];

		this.availableTssModes.forEach( ( tssMode: TssModeEnum ) => {
			let tssManufacturer: TssManufacturerEnum;

			switch ( tssMode ) {
				case TssModeEnum.CLOUD:
					tssManufacturer = TssManufacturerEnum.D_TRUST;
					break;

				case TssModeEnum.OFFLINE:
				case TssModeEnum.TOKEN:
					tssManufacturer = TssManufacturerEnum.CRYPTOVISION;
					break;

				case TssModeEnum.SWISSBIT_TOKEN:
					tssManufacturer = TssManufacturerEnum.SWISSBIT;
			}

			if ( tssManufacturer && !availableTssManufacturers.includes( tssManufacturer ) ) {
				availableTssManufacturers.push( tssManufacturer );
			}
		} );

		return availableTssManufacturers;
	}

	get availableTssModes(): TssModeEnum[] {
		return brandConfig.availableTssModes;
	}

	get availableTssModesWithSubtype(): TssModeWithSubTypeEnum[] {
		return brandConfig.availableTssModesWithSubtype;
	}

	get availableUsageTssTypes(): UsageTssTypeEnum[] {
		return brandConfig.availableUsageTssTypes
		.filter( ( usageTssType: UsageTssTypeEnum ) => {

			switch ( usageTssType ) {
				case UsageTssTypeEnum.CLOUD_FCC_DC:
					return this.supportFccDatacenter;

				default:
					return true;
			}
		} );
	}

	get dashboardPageConfig(): IBrandConfigDashboardPage {
		return brandConfig.dashboardPage;
	}

	get entityErrorDataIntegrityDocumentationUrl(): string {
		return brandConfig.entityErrorDataIntegrity.documentationPortalLink;
	}

	get logoutUrl(): string {
		return brandConfig.logoutUrl;
	}

	get sidebarConfig(): IBrandConfigSidebar {
		return brandConfig.sidebar;
	}

	/**
	 * Universal option to decide FCC-Datacenter usability.
	 */
	get supportFccDatacenter(): boolean {
		return brandConfig.supportFccDataCenter;
	}

	get taskCenterConfig(): IBrandConfigTaskCenter {
		return brandConfig.taskCenter;
	}

	get tenantConsolePage(): IBrandConfigTenantConsolePage {
		return brandConfig.tenantConsolePage;
	}

	get taxationReporting(): IBrandConfigTaxationReporting {
		return brandConfig.taxationReporting;
	}

	get tssLifecycleModal(): IBrandConfigTssLifecycleModal {
		return brandConfig.tssLifecycleModal;
	}

	chartColors( chartColorType: ChartColorTypeEnum ): string[] {
		return brandConfig.chartColors[ chartColorType ]
					 ? brandConfig.chartColors[ chartColorType ]
					 : [];
	}
}
